/**
 * Integrytas Group - Common Security Module (CSM)
 * React entry point.
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
// App-owned Record Extension manifests (§16). Empty in BaseApp — a derived app
// adds its `import './my_extension';` lines to src/app/extensions/index.ts, and
// the side effect must run before the tree mounts so host pages see them.
import './app/extensions';
import { initI18n } from './i18n';
import { bootstrapThemeEarly } from './lib/theme/theme_store';
import { APPLICATION_NAME } from './constants/branding';

// Apply the last-used (or default) theme before the first paint so the login
// screen and initial render are already themed (no flash of the base palette).
bootstrapThemeEarly();

// The browser tab follows the configured app name, never the inherited literal
// in index.html (which is only the pre-JS placeholder). This is the build-time
// half of the branding contract — VITE_APP_NAME via APPLICATION_NAME — so a
// derived app's tab reads its own name without editing any inherited file
// (§16). useBranding() re-applies the DB value post-auth.
document.title = APPLICATION_NAME;

// Initialize i18next before the React tree mounts so the first render of
// any component using useTranslation() resolves correctly.
initI18n();

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('CSM bootstrap failed: missing #root element in index.html');
}

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
